import { PostgrestSingleResponse } from '@supabase/supabase-js';
import { useQuery } from '@tanstack/react-query';
import { CategoryType } from 'sdk/types.d';

import { supabase } from '../api';

const getCategories = async (): Promise<CategoryType[]> => {
  const { data, error }: PostgrestSingleResponse<any[]> = await supabase
    .from('categories')
    .select('*')
    .order('sorting', { ascending: true })

  if (error) {
    throw new Error(error.message);
  }

  return data;
};

export default function useCategories() {
  return useQuery({
    queryKey: ['categories'],
    queryFn: () => getCategories(),
    staleTime: 0,
    cacheTime: 0,
  });
}
